import { render, staticRenderFns } from "./BlackUserManagelist.vue?vue&type=template&id=60eddadb&scoped=true&"
import script from "./BlackUserManagelist.vue?vue&type=script&lang=js&"
export * from "./BlackUserManagelist.vue?vue&type=script&lang=js&"
import style0 from "./BlackUserManagelist.vue?vue&type=style&index=0&id=60eddadb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60eddadb",
  null
  
)

export default component.exports